// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__39bnG","header":"MessagesList_header__350T4","chat":"MessagesList_chat__30PA0"};